import React from "react"
import styled, { css } from "styled-components"
import Breakpoints from "../shared/breakpoints"
import BackgroundImage from "gatsby-background-image"
import Grid from "../shared/grid"
import LinkComponent from "../shared/link"
import { T } from "../shared/typography.styles"
import { useStaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"

const Container = styled(BackgroundImage)`
  .grid-container {
    padding: 32px 0 48px;
    @media (min-width: ${Breakpoints.md}) {
      padding: 64px 0;
    }
    @media (min-width: ${Breakpoints.lg}) {
      padding: 48px 0;
    }
  }
`

const overlayStyle = css`
  background-color: var(--tricorn-black);

  @media (min-width: ${Breakpoints.md}) {
    mix-blend-mode: multiply;
  }
`

const ImageContainer = styled.div`
  display: flex;
  flex-direction: column;
  grid-column: 2 / -2;
  max-height: 371px;

  @media (min-width: ${Breakpoints.md}) {
    grid-column: 1 / 5;
    margin: 0;
    max-height: unset;
    align-self: center;
  }
  @media (min-width: ${Breakpoints.lg}) {
    grid-column: 2 / 5;
  }
`
const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  grid-column: 1 / -1;
  align-self: center;
  align-items: stretch;
  margin-top: 24px;

  @media (min-width: ${Breakpoints.md}) {
    margin-top: 0;
    grid-column: 6 / -1;
    align-items: flex-start;
    padding: 32px 0;
  }
  @media (min-width: ${Breakpoints.lg}) {
    grid-column: 7 / -3;
    padding: 64px 0;
  }
`

const Title = styled.h2`
  ${T.sm.h2.bold}
  color: var(--light-background);
  grid-column: 1 / -1;
  text-align: center;
  box-sizing: border-box;

  @media (min-width: ${Breakpoints.md}) {
    border-left: 4px solid var(--burnt-orange);
    padding-left: 24px;
    text-align: left;
    ${T.md.h2.bold}
  }
  @media (min-width: ${Breakpoints.lg}) {
    ${T.lg.h2.bold}
    margin-right: -40%;
  }
`

const Description = styled.p`
  ${T.sm.body.regular}
  color: var(--light-background);
  grid-column: 1 / -1;
  text-align: center;
  margin-top: 24px;

  @media (min-width: ${Breakpoints.md}) {
    ${T.md.body.regular}
    text-align: left;
  }

  @media (min-width: ${Breakpoints.lg}) {
    ${T.lg.body.regular}
  }
`

const DownloadButton = styled(LinkComponent)`
  justify-self: center;
  background-color: transparent;
  border: 1px solid white;

  width: max-content;
  margin: 32px auto 0;

  @media (min-width: ${Breakpoints.md}) {
    justify-self: left;
    margin: 32px 0 0;
  }
  @media (min-width: ${Breakpoints.lg}) {
    margin-top: 48px;
  }
`

export default function PartnerPDF() {
  const query = useStaticQuery(graphql`
    query {
      lg: file(
        relativePath: {
          eq: "3_RESOURCES/Partner Program/01_desktop/puzzle_background.jpg"
        }
      ) {
        childImageSharp {
          fluid(maxWidth: 1920) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      md: file(
        relativePath: {
          eq: "3_RESOURCES/Partner Program/02_tablet/puzzle background tablet.png"
        }
      ) {
        childImageSharp {
          fluid(maxWidth: 1000) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      sm: file(
        relativePath: {
          eq: "3_RESOURCES/Partner Program/03_mobile/map background mobile.jpg"
        }
      ) {
        childImageSharp {
          fluid(maxWidth: 600) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      bookImg: file(
        relativePath: {
          eq: "3_RESOURCES/Partner Program/01_desktop/program_book.png"
        }
      ) {
        childImageSharp {
          fluid(maxWidth: 1440) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
    }
  `)

  const backgroundSources = [
    query.md.childImageSharp.fluid,
    {
      ...query.md.childImageSharp.fluid,
      media: `(min-width: ${Breakpoints.md})`,
    },
    {
      ...query.lg.childImageSharp.fluid,
      media: `(min-width: ${Breakpoints.lg})`,
    },
  ]

  return (
    <Container fluid={backgroundSources}>
      <Grid overlayStyle={overlayStyle}>
        <ImageContainer>
          <Img
            fluid={query.bookImg.childImageSharp.fluid}
            imgStyle={{ objectFit: "contain" }}
            alt="A printed booklet titled 'Mappedin Partner Program 2020'."
          />
        </ImageContainer>
        <ContentContainer>
          <Title>View the full program</Title>
          <Description>
            View or download the Mappedin Partner PDF to learn more about the
            program and details of what is included in each partner tier.
          </Description>
          <DownloadButton href="/PartnerProgram2020.pdf">
            Download the PDF
          </DownloadButton>
        </ContentContainer>
      </Grid>
    </Container>
  )
}
